import { useState } from "react";
import { articleFeed, categoryTabs } from "@/mocks/guagua";
import SectionHead from "./SectionHead";

const badgeStyle: Record<string, string> = {
  新: "bg-primary-500 text-background-50",
  爆: "bg-primary-500 text-background-50",
};

export default function MelonField() {
  const [active, setActive] = useState("全部瓜");
  const list = active === "全部瓜" ? articleFeed : articleFeed.filter((a) => a.category === active);

  return (
    <section id="guatian" className="scroll-mt-24 lg:scroll-mt-[132px] bg-background-100 border-y border-background-200 py-12 md:py-16">
      <div className="max-w-[1240px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
          <SectionHead
            kicker="GUATIAN·HUIZONG"
            title="今日瓜田汇总"
            desc="热门分类一网打尽，从影视综艺到音乐体育，瓜友们今天都在聊什么，这里都给你整理好了。"
          />
          <div className="flex items-center gap-1 p-1 rounded-full bg-background-50 border border-background-200 flex-wrap w-full lg:w-auto">
            {categoryTabs.map((t) => (
              <button
                key={t}
                onClick={() => setActive(t)}
                className={`px-3 md:px-4 py-1.5 text-sm rounded-full whitespace-nowrap transition-colors ${
                  active === t
                    ? "bg-foreground-950 text-background-50"
                    : "text-foreground-600 hover:text-foreground-900 hover:bg-background-200"
                }`}
              >
                {t}
              </button>
            ))}
          </div>
        </div>

        <div key={active} className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 news-tab-fade">
          {list.map((a) => (
            <article key={a.id} className="group rounded-2xl overflow-hidden bg-background-50 border border-background-200 flex flex-col hover:border-primary-300 transition-colors">
              <div className="relative h-44 overflow-hidden">
                <img
                  src={a.image}
                  alt={`${a.title} 娱乐瓜田资讯配图`}
                  loading="lazy"
                  className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-foreground-950/75 text-background-50 text-xs font-medium backdrop-blur">
                  {a.tag}
                </span>
                {a.badge && (
                  <span className={`absolute top-3 right-3 w-7 h-7 rounded-full ${badgeStyle[a.badge]} text-xs font-bold flex items-center justify-center`}>
                    {a.badge}
                  </span>
                )}
              </div>
              <div className="p-4 md:p-5 flex flex-col flex-1">
                <h3 className="font-heading font-bold text-base text-foreground-950 leading-snug line-clamp-2 group-hover:text-primary-700 transition-colors">
                  {a.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 line-clamp-2 leading-relaxed">{a.summary}</p>
                <div className="mt-auto pt-4 flex items-center justify-between text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i> {a.reads}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i> {a.time}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-8 text-center">
          <button className="px-5 py-2.5 rounded-full border border-foreground-300 text-foreground-800 text-sm font-medium hover:bg-foreground-950 hover:text-background-50 hover:border-foreground-950 transition-colors inline-flex items-center gap-2">
            查看更多今日瓜 <i className="ri-arrow-down-line"></i>
          </button>
        </div>
      </div>
    </section>
  );
}